import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { PayDetail, SearchThirdPartyPay } from '../../models/models';

@Component({
    selector: 'third-party-pay-grid',
    templateUrl: './third-party-pay-grid.component.html',
    standalone: false
})
export class ThirdPartyPayGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() quoteOrderLineID: number = 0;
    @Input() orderNumber: string = "";
    @Input() viewType: string = "quoteorder";
    @Input() pageType: string = "";
    @Input() readonly: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Output() onRefreshTotal = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public thirdPartyPayGrid!: GridComponent;

    public isNew: boolean = false;
    public isEdit: boolean = false;
    public payDetail: PayDetail = {} as PayDetail;
    public payDetailList: SearchThirdPartyPay[] = [];
    public carrierID: number = 0;
    public payStatusAbbrev: string = "";
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'abbrev' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService, private ngZone: NgZone, private utilService: UtilService) { }

    ngOnInit() {
        //this.getPayDetails();
        //console.log("ngOnInit", this.quoteOrderID, this.quoteOrderLineID, this.orderNumber, this.viewType);
    }

    ngOnChanges() {
        this.getPayDetails();
        //console.log("ngOnChanges", this.quoteOrderID, this.quoteOrderLineID, this.orderNumber, this.viewType);
    }

    private getPayDetails() {
        this.utilService.isLoading = true;
        this.payDetailList.length = 0;
        if (this.quoteOrderLineID > 0 && this.viewType == "quoteorderline") {
            this.orderService.getSearchThirdPartyPayByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                this.payDetailList = result.resultCollection;
                //this.getCarrierID();
                this.getPayStatus();
                this.setGrid();
                this.getTotal();
                //console.log("third-party-pay:payDetailList:quoteOrderLineID", this.quoteOrderLineID, this.payDetailList.length);
            });
        }
        if (this.orderNumber != null && this.orderNumber != "" && this.viewType == "ordernumber") {
            this.orderService.getSearchThirdPartyPayByOrderNumber(this.orderNumber).subscribe(result => {
                this.utilService.isLoading = false;
                this.payDetailList = result.resultCollection;
                //this.getCarrierID();
                this.getPayStatus();
                this.setGrid();
                this.getTotal();
                //console.log("third-party-pay:payDetailList:orderNumber", this.orderNumber, this.payDetailList.length);
            });
        }
        if (this.quoteOrderID > 0 && this.viewType == "quoteorder") {
            this.orderService.getSearchThirdPartyPayByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.utilService.isLoading = false;
                this.payDetailList = result.resultCollection;
                //this.getCarrierID();
                this.getPayStatus();
                this.setGrid();
                this.getTotal();
                //console.log("third-party-pay:payDetailList:quoteOrderID", this.quoteOrderID, this.payDetailList.length);
            });
        }
        else {
            this.utilService.isLoading = false;
        }
        this.payDetail = {} as PayDetail;
    }

    //private getCarrierID() {
    //    var lst: SearchThirdPartyPay[] = this.payDetailList.filter(t => t.carrierID && t.carrierID > 0);
    //    if (lst.length > 0) {
    //        this.carrierID = lst[0].carrierID!;
    //    }
    //}

    private getPayStatus() {
        var lst: SearchThirdPartyPay[] = this.payDetailList.filter(t => t.payStatusID && t.payStatusID > 0);
        if (lst.length > 0) {
            this.payStatusAbbrev = lst[0].payStatusAbbrev;
        }
    }

    private getTotal() {
        var total = this.payDetailList.reduce(function (prev, cur) {
            return prev + (cur.amount != null ? cur.amount : 0);
        }, 0);
        //console.log("third-party-pay:getTotal", total);
        this.onRefreshTotal.emit(total);
    }

    private setGrid() {
        this.gridData = process(this.payDetailList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.thirdPartyPayGrid == null) return;
            this.thirdPartyPayGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.payDetailList, this.gridState);
    }

    public canEdit(payDetail: SearchThirdPartyPay) {
        var isValid: boolean = true;
        var diffDays = 0;
        if (payDetail.lastCompletedDate != null) {
            diffDays = this.utilService.getDateDiffDays(new Date(payDetail.lastCompletedDate), new Date());
        }
        else {
            diffDays = this.utilService.getDateDiffDays(new Date(payDetail.createDate), new Date());
        }
        if (diffDays > 60) {
            isValid = false;
        }
        if (payDetail.payToID == null || payDetail.payToID == 0) {
            isValid = false;
        }
        if (payDetail.assignToID == null || payDetail.assignToID == 0) {
            isValid = false;
        }
        if (payDetail.payStatusAbbrev != "HLD") {
            isValid = false;
        }
        return isValid;
    }

    public addNew() {
        var employeeID = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
        this.payDetail = {
            payDetailId: 0,
            quoteOrderLineId: this.quoteOrderLineID,
            orderNumber: this.orderNumber,
            payDetailTypeId: 0,
            assignToId: 0,
            payStatusId: 0,
            erpItemCode: "",
            authCode: "",
            description: "",
            quantity: 0,
            unit: "",
            rate: 0,
            amount: 0,
            notes: "",
            transactionDate: new Date(),
            createdByEmployeeId: employeeID,
            createDate: new Date()
        };
    }

    public edit(payDetail: SearchThirdPartyPay) {
        //console.log("edit", payDetail);
        this.orderService.getPayDetailByID(payDetail.payDetailID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.payDetail = result.resultCollection[0];
                var employeeID = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
                this.payDetail.lastModifiedByEmployeeId = employeeID;
            }
        });
        //this.payDetail = Object.assign({}, payDetail);
    }

    public delete(payDetail: SearchThirdPartyPay) {
        //console.log("edit", payDetail);
        if (confirm("Delete " + payDetail.payDetailTypeAbbrev + "?")) {
            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Third Party Pay Grid Delete");
            this.orderService.deletePayDetailByID(payDetail.payDetailID).subscribe(result => {
                console.log("deletePayDetail", result, payDetail);
                this.getPayDetails();
            });
        }
        //this.payDetail = Object.assign({}, payDetail);
    }
}
